<template>
  <div class="container pl-0 pr-0">
    <div
      class="modal fade inactivity"
      tabindex="-1"
      id="wasteDependencyModal"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content text-center">
          <div class="modal-body p-4">
            <p>
              A hard waste booking is required for this add on. Please select
              hard waste to enable this option.
            </p>
            <button
              type="button"
              class="btn btn-tru-green w-auto btn--yes"
              data-bs-dismiss="modal"
            >
              Okay
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row pl-3 d-block">
      <!-- Heading -->
      <h6 class="pl-0 font-weight-bold" v-html="heading"></h6>
      <label v-if="subHeading" v-html="subHeading"></label>
    </div>
    <div class="row">
      <!-- Waste Selection -->
      <!-- 
        Stry: US411 update
        Date: 2020-11-06
        Auth: Franco Mapua
        Desc: Changing the display of the waste stream loader to an animated image
       -->
      <div class="text-left col" v-if="isLoadingWasteStreams">
        <div class="spinner spinner--1"></div>
      </div>
      <div class="text-left col" v-else-if="!isLoadingWasteStreams">
        <!-- Waste Streams -->
        <WasteStreamOption
          v-for="wasteStream in visibleWasteStreams"
          :key="wasteStream.waste_stream_setting_id"
          :data="wasteStream"
          :isPaid="selectedService && selectedService.is_paid == 2"
          :isMultipleSelection="
            selectedService && selectedService.is_multiple_waste_selection == 2
          "
          :isMultipleCollection="isDisplayStreamQuantities"
          :multipleCollectionCount="multipleCollectionCount"
          :isDisplayMaxQuantity="isDisplayMaxQuantity"
          @update="
            (wasteStreamSelection) =>
              handleWasteStreamUpdate(wasteStreamSelection)
          "
          :removeProduct="removeProduct"
          :selectedBookingProducts="selectedBookingProducts"
          @invalidWaste="invalidWaste"
          @showAlert="showAlert"
        />
        <!-- Fake Waste Streams -->

        <WasteStreamOption
          v-for="wasteStream in fakeWasteStreams"
          :isFake="true"
          :key="wasteStream.waste_stream_setting_id"
          :data="wasteStream"
          :isPaid="selectedService && selectedService.is_paid == 2"
          :isMultipleSelection="
            selectedService && selectedService.is_multiple_waste_selection == 2
          "
          :isMultipleCollection="isDisplayStreamQuantities"
          :multipleCollectionCount="multipleCollectionCount"
          :isDisplayMaxQuantity="isDisplayMaxQuantity"
          @update="(wasteStreamSelection) => emitUpdate(wasteStreamSelection)"
          @showAlert="showAlert"
          :removeProduct="removeProduct"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WasteStreamOption from "./WasteStreamOption";
import Texts from "../../../../common/utils/Texts";
import helper from "../../../../helper";

export default {
  components: {
    WasteStreamOption,
  },
  props: {
    selectedServiceCart: Object,
    selectedService: Object,
    resetOnServiceChange: {
      type: Boolean,
      default: false,
    },
    removeProduct: Array,
  },
  data() {
    return {
      wasteStreams: [],
      fakeWasteStreams: [],
      wasteStreamCache: [],
      isLoadingWasteStreams: false,
      wasteStreamModalText : "",
      visibleWasteStreams: []
    };
  },
  computed: {
    TEXTS: () => Texts,
    bookingState() {
      return this.$store.getters.GET_BOOKING_STATE;
    },
    selectedServiceId() {
      return this.selectedService
        ? this.selectedService.service_setting_id
        : null;
    },
    selectedServiceName() {
      return this.selectedService ? this.selectedService.service_name : null;
    },
    isDisplayStreamQuantities() {
      return this.bookingState
        ? this.bookingState.displayStreamQuantities
        : false;
    },
    selectedServiceWording() {
      if (this.bookingState && this.bookingState.selectedService) {
        return this.bookingState.selectedService.wording;
      }

      return null
    },
    heading() {
      var selectedServiceName = this.selectedService
        ? this.selectedService.service_name
        : null;

      if (
        this.selectedServiceWording &&
        this.selectedServiceWording.waste_heading
      ) {
        return this.selectedServiceWording.waste_heading; // Change Later
      } else {
        let renderSpecifier =
          selectedServiceName &&
          (selectedServiceName.toLowerCase().indexOf("bin repair") > -1 ||
            selectedServiceName.toLowerCase().indexOf("bin replace") > -1)
            ? "options"
            : "default";
        return Texts.render(`SELECT_WASTE_TYPE_HEADER`, renderSpecifier);
      }
    },
    subHeading() {
      if (
        this.selectedServiceWording &&
        this.selectedServiceWording.waste_subheading
      ) {
        return this.selectedServiceWording.waste_subheading;
      } else {
        var serviceNameShortForm =
          this.selectedServiceName &&
          this.selectedServiceName
            .toLowerCase()
            .indexOf("free booked hard waste") > -1
            ? "freeHardWaste"
            : null;
        return Texts.render("WASTE_SELECTION_SUBHEADING", serviceNameShortForm);
      }
    },
    multipleCollectionCount() {
      return this.bookingState
        ? this.bookingState.multipleCollectionCount
        : null;
    },
    isDisplayMaxQuantity() {
      // --- Get multiple collection settings
      var isDisplayMaxQuantity;

      isDisplayMaxQuantity = this.activeMultipleCollectionSetting
        ? this.activeMultipleCollectionSetting.per_service == "1"
        : false;

      return isDisplayMaxQuantity;
    },
    activeMultipleCollectionSetting() {
      return this.$store.getters.GET_ACTIVE_MULTIPLE_COLLECTION_SETTING;
    },
    selectedBookingProducts() {
      /**
      * Stry: RP-109
      * Date: 2021-04-16
      * Auth: Joseph Ricohermoso
      * Desc: Enable multiservice retrieval
      */
      return !this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED ?
        this.bookingState.selectedBookingProducts
        : this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS;
    },
    GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED() {
      return this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED;
    },
  },
  watch: {
    selectedService(service) {
      if (!service || !service.service_setting_id) {
        this.wasteStreams = [];
        this.fakeWasteStreams = []; // 2021-05-05 BAUM-325 Author: Joseph
        return;
      }

      // Load Waste Streams
      this.isLoadingWasteStreams = true;
      var foundCacheIndex = this.wasteStreamCache.findIndex(
        (cache) => cache.service_setting_id == service.service_setting_id
      );

      if (foundCacheIndex != -1) {
        this.wasteStreams = this.wasteStreamCache[foundCacheIndex].wasteStreams;
        this.$store.commit("SET_VIEW_WASTE_STREAMS", this.wasteStreams);
        this.$store.commit("SET_LOADED_WASTE_STREAMS", this.wasteStreams.list || [] );
        this.isLoadingWasteStreams = false;

        /**
         * 2021-05-05
         * BAUM-325
         * Author: Joseph
         * Desc: Upon selecting a service we need to reinitialize the fake streams since jumping between services does not remounting this component
         */
        this.hyrateFakeStreamOptions(
          (this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED && this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS) || []
        );
      } else {
        this.$store
          .dispatch("getWasteStreamsOfService", this.selectedServiceId)
          .then((result) => {
            this.wasteStreamCache.push({
              service_setting_id: service.service_setting_id,
              wasteStreams: result,
            });
            this.wasteStreams = result;
            this.$store.commit("SET_VIEW_WASTE_STREAMS", { list: result });
            this.$store.commit("SET_LOADED_WASTE_STREAMS", result );

            /**
             * 2021-05-05
             * BAUM-325
             * Author: Joseph
             * Desc: Upon selecting a service we need to reinitialize the fake streams since jumping between services does not remounting this component
             */
            this.hyrateFakeStreamOptions(
              (this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED && this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS) || []
            );
            this.runFilterVisibleWasteStreams();
            this.isLoadingWasteStreams = false;
          })
          .catch((err) => {
            console.log('Error with get waste stream by by service');
            this.isLoadingWasteStreams = false;
          });
      }
    },
    selectedBookingProducts(newValue, oldValue) {
      if (JSON.stringify(newValue) == JSON.stringify(oldValue)) {
        return;
      }

      /**
      * Stry: RP-109
      * Date: 2021-04-16
      * Auth: Joseph Ricohermoso
      * Desc: In multiservice, retrieving the multiservice booking products returns the old content.
      *       Therefore if expected to return empty array it'll still return the last array content.
      */
      // --- Fake Streams
      // if (this.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED) {
      //   newValue = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS.map(
      //     (bookingProduct) => bookingProduct
      //   );
      // }

      var selectedServiceName = this.selectedServiceName;

      /**
       * 2021-05-05
       * BAUM-325
       * Author: Joseph
       * Desc: Upon selecting a service we need to reinitialize the fake streams since jumping between services does not remounting this component
       */
      this.hyrateFakeStreamOptions(newValue);
      this.filterVisibleWasteStreams(newValue);
      var fakeStreams = this.fakeWasteStreams;

      if (
        fakeStreams &&
        Array.isArray(fakeStreams.purge) &&
        fakeStreams.purge.length > 0
      ) {
        var payload = {};
        var option_id;
        fakeStreams.purge.forEach((fakeStream) => {
          payload[`waste${fakeStream.waste_stream_setting_id}`] = { qty: 0 };
          option_id = fakeStream.waste_stream_setting_id;
        });
        this.emitUpdate(payload);
        this.$store.dispatch(
          "setActiveMultipleServiceSelectedBookingProducts",
          {
            data: {
              option_id,
              fake_stream_id: `waste${option_id}`,
            },
            adding: false,
          }
        );
      }

      // Find checked child wastesteam and remove it if the parent is not checked
      const selectedWasteSteamsIds = this.selectedBookingProducts.map((e) => e.waste_stream_setting_id);
      const toRemoveChildWasteStreams = this.selectedBookingProducts.filter(
        (e) => e.dependency_waste_stream_setting_id
            && selectedWasteSteamsIds.indexOf(e.dependency_waste_stream_setting_id) === -1
      );
      // Remove special option if the parent is not checked
      this.removeSpecialOptions(selectedWasteSteamsIds, toRemoveChildWasteStreams);

      if (toRemoveChildWasteStreams.length > 0) {
        toRemoveChildWasteStreams.forEach((e) => {
            const payload = {};
            payload[`${e.option_id}`] = {...e, ...{qty: 0}};
            this.$emit("update", payload);
            this.$store.dispatch(
              "setActiveMultipleServiceSelectedBookingProducts",
              {
                  data: e,
                  adding: false,
                  isInputModel: true,
                  isInputModelType: "checkbox",
                  isParent: false,
                  isParentInputModelType: "radio",
                  isSpinnerModel: false
              }
            );
        })
        this.$store.dispatch('removeDependentWasteStream', toRemoveChildWasteStreams.map((e) => e.option_id));
        this.$emit('removeDependentWasteStream', toRemoveChildWasteStreams.map((e) => e.option_id));
      }
      // --- Waste Dependencies
      var wasteStreamDependencies = helper.checkProductsForInvalidDependentStreams(
        newValue,
        selectedServiceName
      );

      if (
        Array.isArray(wasteStreamDependencies) &&
        wasteStreamDependencies.length > 0
      ) {
        var instructions = {};

        wasteStreamDependencies.forEach((dependent) => {
          instructions[dependent.parent_option_id || dependent.option_id] = 0;
        });

        this.broadcastChangeInstructions(instructions);
        var oldValueLength = oldValue.filter(product => product.qty > 0)
        var newValueLength = newValue.filter(product => product.qty > 0)
        var isAdding = oldValueLength < newValueLength

        if(isAdding){
          $("#wasteDependencyModal").modalbs5({
            show: true,
            backdrop: "static",
            keyboard: false,
          });
        }

        /**
        * Story:  RP-128
        * Author: Joseph
        * Desc:   In Brim, when a waste is selected and has dependency that waste wouldn't be selected BUT still added to cart.
        *         By the time you select any waste without waste dependency the calendar wont enable (it should) bcoz a faulty
        *         waste is added to cart with -1 quantity (the waste with dependency).
        *         Fix is to remove the waste from cart once propmted to have waste dependency
        */
        const self = this;
        setTimeout(function() {
          wasteStreamDependencies = wasteStreamDependencies.map(uSP => uSP.option_id);
          self.$store.dispatch('removeDependentWasteStream', wasteStreamDependencies);
          self.$emit('removeDependentWasteStream', wasteStreamDependencies);
        }, 1000);

      }
    },
    wasteStreams(newValue){
      /*
        Stry: DEF_089_TEST2: Auto select waste stream if only 1 waste stream is displayed for the service
        Date: 2021-01-11
        Auth: Franco Mapua
        Desc: Adding new formatter for version
      */
      if(Array.isArray(newValue) && newValue.length == 1){
        if(Array.isArray(this.selectedBookingProducts) && this.selectedBookingProducts.length == 0) {
          // --- Allow Time to Render
          setTimeout(() => {
            var wasteStream = newValue[0]
            var wasteId = `wasteStreamTogglewaste${wasteStream.waste_stream_setting_id}`;
            const $wasteEl = document.getElementById(wasteId);
            // If waste not check => click
            if (!$wasteEl.checked) {
              if (wasteStream.preselected) {
                $wasteEl.disabled = false;
              }
              $wasteEl.click();
              $wasteEl.disabled = wasteStream.preselected;
            }
          }, 1000);

        }
      }
      this.runFilterVisibleWasteStreams();
    }
  },
  methods: {
    removeSpecialOptions(checkedWasteSteamsIds, toRemoveChildWasteStreams) {
      const selectedSpecialOptions = this.$store.getters.GET_BOOKING_STATE.selectedSpecialOptions || {};

      Object.keys(selectedSpecialOptions).forEach(wasteStreamId => {
        const wasteStreamIdNumber = Number(wasteStreamId);
        const specialOption = selectedSpecialOptions[wasteStreamId];
        const dependencyId = specialOption.dependency_waste_stream_setting_id;

        if (dependencyId) {
            // it has parent but the parent is not checked
            if(checkedWasteSteamsIds.indexOf(Number(dependencyId)) === -1) {
                this.removeSpecialOption(wasteStreamIdNumber);
            }
        } else {
          // in to remove list
          if (toRemoveChildWasteStreams.indexOf(wasteStreamIdNumber) !== -1) {
            console.log('448 removeSpecialOption in to remove list');
            this.removeSpecialOption(wasteStreamIdNumber);
          }
        }
      });
    },
    removeSpecialOption(wasteStreamId) {
      const selectedSpecialOptions = this.$store.getters.GET_BOOKING_STATE.selectedSpecialOptions || {};
      if (!(wasteStreamId in selectedSpecialOptions)) {
        return;
      }

      const {
        [wasteStreamId]: removed,
        ...remainingOptions
      } = selectedSpecialOptions;

      this.$store.dispatch('setBookingState', {
        selectedSpecialOptions: remainingOptions
      });
    },

    loadWasteStreamState(serviceCartState) {
      // ---
      this.$emit("loadWasteStreamState", serviceCartState);
    },
    handleWasteStreamUpdate(wasteStreamSelection) {
      this.$emit("update", wasteStreamSelection);
    },
    broadcastChangeInstructions(changeInstructions) {
      this.$emit("broadcastChangeInstructions", changeInstructions);
    },
    emitUpdate(wasteStreamSelection) {
      this.$emit("update", wasteStreamSelection);
    },
    showAlert(message) {
      $("#wasteStreamAlertModal-content").html(message);
      $("#wasteStreamAlertModal").modalbs5('show');
    },
    filterVisibleWasteStreams(newValue) {
        const checkedWasteSteamsId = newValue.map((e) => e.waste_stream_setting_id);
        this.visibleWasteStreams = this.wasteStreams.filter((e) => !e.dependency_waste_stream_setting_id || (e.dependency_waste_stream_setting_id && checkedWasteSteamsId.indexOf(e.dependency_waste_stream_setting_id) !== -1));
    },
    runFilterVisibleWasteStreams() {
      const selectedBookingProducts = this.selectedBookingProducts;
      const selectedWasteSteamsIds = selectedBookingProducts.map((e) => e.waste_stream_setting_id);
      this.visibleWasteStreams = this.wasteStreams.filter(
        (e) => !e.dependency_waste_stream_setting_id
          || (e.dependency_waste_stream_setting_id && selectedWasteSteamsIds.indexOf(e.dependency_waste_stream_setting_id) !== -1)
        );
    },
    /**
     * 2021-05-05
     * BAUM-325
     * Author: Joseph
     * Desc: Upon selecting a service we need to reinitialize the fake streams since jumping between services does not remounting this component
     */
    hyrateFakeStreamOptions(selectedProducts) {
      let fakeStreams = null;

      if (selectedProducts.length > 0)
        {
        fakeStreams = helper.getFakeStreamsOfCart(selectedProducts, this.selectedServiceName)
        }

      this.fakeWasteStreams = (fakeStreams && fakeStreams.list) || [];
    },
    invalidWaste() {
      if(this.wasteStreams.length == 1) {
        var $self = this;
        $("#wasteStreamAlertModal").on('hidden.bs.modal', function () {
          $self.resetService();
        });
      }
    },
    resetService() {
      if(this.wasteStreams.length == 1) {
        var bookingState = this.bookingState;
        bookingState.selectedService = null;
        this.$store.dispatch('resetActiveServiceSetting', null);
        this.$store.dispatch('setBookingState', bookingState);
      }
    }
  },
};
</script>

<style>
.spinner {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}
.spinner--1 {
  border-top: 2px solid #c7c7c7;
  animation: spinner1 600ms linear infinite;
}
@keyframes spinner1 {
  to {
    transform: rotate(360deg);
  }
}
</style>
